import React, { createContext, useState, useContext, useCallback } from 'react';

const PageHeaderContext = createContext();

export const PageHeaderProvider = ({ children }) => {
    const [title, setTitle] = useState('');
    const [subTitle, setSubTitle] = useState('');

    // Helper to set title and subTitle
    const setPageHeader = useCallback((newTitle, newSubTitle = '') => {
        setTitle(newTitle);
        setSubTitle(newSubTitle);
    }, []);

    // Alias for setPageTitle (legacy support)
    const setPageTitle = setPageHeader;

    // Helper to reset title (e.g., on unmount)
    const resetPageTitle = useCallback(() => {
        setTitle('');
        setSubTitle('');
    }, []);

    return (
        <PageHeaderContext.Provider value={{ title, subTitle, setPageHeader, setPageTitle, resetPageTitle }}>
            {children}
        </PageHeaderContext.Provider>
    );
};

export const usePageHeader = () => {
    const context = useContext(PageHeaderContext);
    if (!context) {
        throw new Error('usePageHeader must be used within a PageHeaderProvider');
    }
    return context;
};
